module.exports = __webpack_public_path__ + "img/SketchPng03aadd83c9256b6ad18eb75018f06b02867ec713844f8dce9e5ce8c18034a905.d6e3e33e.png";